export default __webpack_public_path__ + "static/media/contact.e85b26b1.svg";